import React from 'react';
import Popup from 'react-popup';
import { createGlobalStyle } from 'styled-components/macro';
import { popupButtonStyles, popupButtonDismissStyles, popupButtonConfirmStyles } from '../Popups.styles';

const ConfirmPopup = () => {
  return (
    <React.Fragment>
      <PopupGlobalStyles />
      <Popup
        className="confirm-popup"
        btnClass="confirm-popup__btn"
        closeBtn={false}
        wildClasses={false}
        closeOnOutsideClick={true}
      />
    </React.Fragment>
  );
};

export default ConfirmPopup;

const PopupGlobalStyles = createGlobalStyle`
.confirm-popup {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1000;
  overflow: auto;
  display: none;
  /*to adjust backgroud overlay*/
  background: rgba(0, 0, 0, 0.3);
}

.confirm-popup--visible {
  display: flex;
  align-items: center;
  justify-content: center;
}

/*Popup box styling*/
.confirm-popup__box {
  background: var(--base-background);
  color: var(--base-text);
  box-shadow: 0px 8px 8px rgba(0, 0, 0, 0.1);
  margin: auto;
  z-index: 100;
}

.confirm-popup__box__body {
  line-height: 1.4;
  font-size: 14px;
  text-align: center;
  color: var(--base-text);
  background: var(--base-background);
  position: relative;
  z-index: 2;
  border-radius: 3px;
}

.confirm-popup__box__footer {
  overflow: hidden;
}

.confirm-popup__btn {
  ${popupButtonStyles}
}

.confirm-popup__btn--confirm {
  ${popupButtonConfirmStyles}
}

.confirm-popup__btn--dismiss {
  ${popupButtonDismissStyles}
}

.confirm-popup__btn--reject {
  background-color: var(--new-ticket-popup-header-background);
  color: var(--dark-gray1);
  font-family: 'Lato', sans-serif;
  transition: 0.3s;
}

.confirm-popup__btn--respond-now {
  background-color: var(--simplr-blue);
  font-family: 'Lato', sans-serif;
  color: #fff;
  transition: 0.3s;
}

.confirm-popup__btn--dismiss:hover,
.confirm-popup__btn--confirm:hover,
.confirm-popup__btn--one-btn-dismiss:hover,
.confirm-popup__btn--one-btn-confirm:hover,
.confirm-popup__btn--reject:hover,
.confirm-popup__btn--respond-now:hover
{
  background-color: var(--app-btn-hover);
  color: var(--white-text);
}

.confirm-popup__btn--one-btn-dismiss {
  width: 100%;
  background-color: var(--app-surface-alt);
  color: var(--dark-gray1);
  transition: 0.3s;
}

.confirm-popup__btn--one-btn-confirm {
  width: 100%;
  background-color: var(--simplr-blue);
  color: #fff;
  transition: 0.3s;
}

/* TODO - improve responsive styling */
@media (max-width: 420px) {
  .confirm-popup__box {
    width: auto;
    left: 10px;
    right: 10px;
    top: 10px;
    margin-left: 0;
    margin: auto;
  }
}

@media screen and (max-width: 1024px) {
  .confirm-popup__btn {
    font-size: 10px;
  }
}

@media screen and (max-height: 569px), screen and (max-width: 800px) {
  .confirm-popup__btn {
    font-size: 9px;
  }
}
`;
